const isRequiredOptions = [
    {text: '필수', value: true},
    {text: '선택', value: false},
];
const valueTypeOptions = [
    {text: '정수', value: 'int'},
    {text: '문자열', value: 'str'},
    {text: '선택 목록', value: 'list'},
];

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'key_name',
        label: '키 이름',
        thStyle: {
            width: '150px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'project_id',
        label: '프로젝트 ID',
        thStyle: {
            width: '200px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'value_type',
        label: '타입',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'is_required',
        label: '필수 입력',
        thStyle: {
            width: '80px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'sort_order',
        label: '정렬 순서',
        thStyle: {
            width: '80px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'detail',
        label: '상세/복사',
        thStyle: {
            width: '140px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '수정일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
];


const allowValuesColumn = [
    {
        key: 'sort_order',
        label: '순서',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0', 'text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'actual_value',
        label: '실제 값',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_key',
        label: '라벨 키',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_texts_ko',
        label: '한국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_texts_en',
        label: '영어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
    {
        key: 'label_texts_ca',
        label: '중국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate']
    },
];



export {columns,isRequiredOptions,valueTypeOptions, allowValuesColumn};
